<template>
  <div class="NonFullPartnerRequestedOfferCardContainer">
    <HotOfferCard
      v-bind="$attrs"
      :tag-type="cptdOfferTag.type"
      :tag-label="cptdOfferTag.label"
      :interest-rate="
        offer.display_interest_rate_monthly || offer.interest_rate_monthly || 0
      "
      :installment-value="offer.installment_amount"
      :duration="offer.duration"
      :amount="offer.amount"
      :partner="offer.partner"
      :cta-label="cptdLblButton"
      @action-forward-click="onClick"
      @brand-click="onClick"
      @offer-conditions-click="onClick"
    />
    <slot name="modal" />
  </div>
</template>
<script>
import { UIFeedbackTypes } from '@/helpers/offer-types'
import { OfferStatus, OfferSubStatus } from '@/data/common'
import { PartnerByPassStatusCheck } from '@/helpers/partners/common'
import HotOfferCard from '~/aasgard/components/cards/HotOfferCard.vue'
export default {
  name: 'NonFullPartnerRequestedOfferCardContainer',
  components: {
    HotOfferCard,
  },
  props: {
    offer: { type: Object, required: true },
  },
  emits: ['display-partner-steps'],
  data() {
    return {
      OfferSubStatusMessagesEnum: {
        UNKNOWN_OFFER_SUB_STATUS: 'Aguardando resposta da parceira',
        AGREEMENT_ACCEPTED: 'Oferta solicitada',
        WAITING_FOR_VALIDATION: 'Aguardando resposta da parceira',
        SUBMITTED_FOR_SELECTION: 'Aguardando resposta da parceira',
        SELECTED: 'Oferta solicitada',
        WAITING_FOR_DATA: 'Oferta solicitada',
        WAITING_FOR_DOCUMENT_UPLOADS: 'Oferta solicitada',
        WAITING_FOR_AGREEMENT_ACCEPTANCE: 'Oferta solicitada',
        INFORMATION_INCORRECT: 'Problema nos dados enviados',
        PROBLEM_WITH_DOCUMENT: 'Problema nos documentos enviados',
      },
      OfferSubStatusUIFeedbackEnum: {
        UNKNOWN_OFFER_SUB_STATUS: 'NEUTRAL',
        WAITING_FOR_VALIDATION: 'NEUTRAL',
        SUBMITTED_FOR_SELECTION: 'NEUTRAL',
        SELECTED: 'POSITIVE-LIGHT',
        WAITING_FOR_DATA: 'POSITIVE-LIGHT',
        WAITING_FOR_DOCUMENT_UPLOADS: 'POSITIVE-LIGHT',
        WAITING_FOR_AGREEMENT_ACCEPTANCE: 'POSITIVE-LIGHT',
        AGREEMENT_ACCEPTED: 'POSITIVE-LIGHT',
        INFORMATION_INCORRECT: 'ERROR',
        PROBLEM_WITH_DOCUMENT: 'ERROR',
      },
    }
  },
  computed: {
    cptdOfferTag() {
      switch (this.offer.status) {
        case OfferStatus.ONGOING:
          return {
            label: this.OfferSubStatusMessagesEnum[this.offer.sub_status],
            type: UIFeedbackTypes[
              this.OfferSubStatusUIFeedbackEnum[this.offer.sub_status]
            ],
          }
        case OfferStatus.FATAL_ERROR:
          return {
            label: this.OfferSubStatusMessagesEnum[this.offer.sub_status],
            type: UIFeedbackTypes.ERROR,
          }
        default:
          return null
      }
    },
    cptdLblButton() {
      const { sub_status } = this.offer
      const lblDefault = 'Continuar'

      if (PartnerByPassStatusCheck[this.offer?.partner]) {
        return lblDefault
      }

      switch (sub_status) {
        case OfferSubStatus.INFORMATION_INCORRECT:
        case OfferSubStatus.PROBLEM_WITH_DOCUMENT:
        case OfferSubStatus.UNKNOWN_OFFER_SUB_STATUS:
        case OfferSubStatus.SUBMITTED_FOR_SELECTION:
          return 'Oferta solicitada'
        default:
          return lblDefault
      }
    },
    cptdButtonDisabled() {
      const { sub_status } = this.offer

      if (PartnerByPassStatusCheck[this.offer?.partner]) {
        return false
      }

      switch (sub_status) {
        case OfferSubStatus.INFORMATION_INCORRECT:
        case OfferSubStatus.PROBLEM_WITH_DOCUMENT:
        case OfferSubStatus.UNKNOWN_OFFER_SUB_STATUS:
        case OfferSubStatus.SUBMITTED_FOR_SELECTION:
          return true
        default:
          return false
      }
    },
  },
  methods: {
    onClick() {
      this.$emit('display-partner-steps')
    },
  },
}
</script>
